import styled from 'styled-components'

export const Point = styled.div`
  border-radius: 50% 50% 50% 0;
  background-color: #e74c3c;
  border: 4px solid #c0392b;
  width: 20px;
  height: 20px;
  transform: rotate(-45deg);
`

export const MapContainer = styled.div.attrs({ className: 's-rounded' })`
  width: 100%;
  height: 200px;
`

export const MapMarker = styled.div`
  width: 10px;
  height: 10px;
  border-radius: 5px;
  background-color: #e49042;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -100%);
`
